import { Field, Switch } from '@headlessui/react';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { Tooltip } from '@mui/material';

import { classNames } from '../../../common/lib/classNames';
type FrozenToggleProps = {
  name: string;
  value: boolean;
  onChange: (value: { value: boolean; name: string }) => void;
  activeText: string;
  inactiveText: string;
  className?: string;
  disabled?: boolean;
  tooltip: string;
}

export function FrozenToggle({ name, value, onChange, activeText, inactiveText, className, disabled, tooltip }: FrozenToggleProps) {
  return (
    <Field
      disabled={ disabled }
    >
      <Tooltip title={ tooltip }>
        <Switch
          checked={ value }
          onChange={ val => onChange({ value: val, name }) }
          className={ classNames(
            `relative inline-flex h-10 w-[120px] shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-300 items-center justify-between`,
            value
              ? `bg-blue-400 border-blue-400`
              : `bg-white border-gray-300`,
            className,
          ) }
        >
          <span className={ `sr-only` }>{ `Frozen status` }</span>
          <span
            className={ classNames(
              `absolute inset-y-0 flex items-center text-sm font-medium transition-opacity duration-300 whitespace-nowrap w-full`,
              value ? `text-white justify-start pl-1` : `text-gray-400 justify-end pr-1.5`,
            ) }
          >
            { value ? activeText : inactiveText }
          </span>
          <span
            className={ classNames(
              `h-8 w-8 transform rounded-full transition-transform duration-500 shadow-md flex items-center justify-center self-center`,
              value ? `translate-x-[88px] bg-white text-blue-400 rotate-720` : `translate-x-[2px] bg-gray-300 text-gray-400 rotate-0`,
            ) }
          >
            <AcUnitIcon fontSize={ `small` } />
          </span>
        </Switch>
      </Tooltip>
    </Field>
  );
}
